import {DocumentPhoto} from 'presentation/pages/others/facial-biometrics/pages';
import React from 'react';

export const MakeDocumentPhoto: React.FC = () => <DocumentPhoto />;
